import OliverText from "../OliverText";
import "./style.scss";

interface SkeletonInputProps {
    title?: string;
}

const SkeletonInput = ({ title }: SkeletonInputProps) => {
    return (
        <div style={{display: "flex", flexDirection: 'column', gap: "4px"}}>
            {title && <OliverText text={title} size="xs" />}
            <div className="select-input-wrapper-con skeleton">
                <div className="select-wrapper-con skeleton">
                    <input />
                </div>
            </div>
        </div>
    );
};

export default SkeletonInput;
